import { MerchantInfo, TILE_SIZE } from "./common";

export class Merchant {
  info: MerchantInfo;
  sprite?: Phaser.GameObjects.Image;
  outlineGraphics?: Phaser.GameObjects.Graphics;

  constructor(info: MerchantInfo, sprite?: Phaser.GameObjects.Image) {
    this.info = info;
    this.sprite = sprite;
  }

  // Returns true if the player is adjacent (including diagonals)
  isPlayerAdjacent(playerTileX: number, playerTileY: number): boolean {
    const dx = Math.abs(this.info.x - playerTileX);
    const dy = Math.abs(this.info.y - playerTileY);
    return dx <= 1 && dy <= 1 && !(dx === 0 && dy === 0);
  }

  // Returns true if the player is on the same tile as the merchant
  isPlayerOnSameTile(playerTileX: number, playerTileY: number): boolean {
    return this.info.x === playerTileX && this.info.y === playerTileY;
  }

  // Draws a white outline around the merchant sprite when highlighted
  renderOutline(scene: Phaser.Scene) {
    const px = this.info.x * TILE_SIZE;
    const py = this.info.y * TILE_SIZE;
    if (!this.outlineGraphics) {
      this.outlineGraphics = scene.add.graphics();
      this.outlineGraphics.setDepth(1); // Same depth as tile-effects layer

      // Ensure outline is only visible in the main camera, not the UI camera
      const cameras = scene.cameras.cameras;
      cameras.forEach((camera: Phaser.Cameras.Scene2D.Camera) => {
        if (camera !== scene.cameras.main) {
          camera.ignore(this.outlineGraphics!);
        }
      });
    }
    this.outlineGraphics.clear();
    this.outlineGraphics.lineStyle(3, 0xffffff, 1);
    this.outlineGraphics.strokeRect(px, py, TILE_SIZE, TILE_SIZE);
    this.outlineGraphics.visible = true;
  }

  hideOutline() {
    if (this.outlineGraphics) {
      this.outlineGraphics.visible = false;
    }
  }

  remove() {
    this.sprite?.destroy();
    this.sprite = undefined;
    this.outlineGraphics?.destroy();
    this.outlineGraphics = undefined;
  }
}
